import isPropValid from '@emotion/is-prop-valid';
import { styled } from '@mui/material';

import { FC, ReactNode } from 'react';

const StyledPageContainer = styled('div', {
  shouldForwardProp: isPropValid
})<{ hasNav?: boolean }>(props => ({
  display: 'grid',
  flex: 1,
  gridTemplateAreas: `
    'topBar topBar topBar topBar'
    'sideNav banner banner banner'
    'sideNav drawer page shelf'
    'sideNav drawer pageFooter shelf'
  `,
  gridTemplateColumns: 'auto auto minmax(0, 1fr) auto',
  gridTemplateRows: 'auto auto minmax(0, 1fr) auto',
  height: '100vh',
  overflow: 'hidden',
  position: 'relative',
  width: '100%',
  [props.theme.breakpoints.down('sm')]: {
    gridTemplateAreas: `
      'topBar'
      'banner'
      'page'
      'pageFooter'
      'bottomNav'
    `,
    gridTemplateColumns: '1fr',
    gridTemplateRows: 'auto auto 1fr auto auto'
  }
}));

export const PageContainer: FC<{
  children: ReactNode;
  hasNav?: boolean;
}> = ({ hasNav = true, ...props }) => {
  return (
    <StyledPageContainer hasNav={hasNav}>{props.children}</StyledPageContainer>
  );
};

PageContainer.displayName = 'PageContainer';
